import React from 'react';
import CompliancePage from '../components/CompliancePage';
import { COMPLIANCE_PAGES } from '../config';

const PrivacyPolicyPage = () => {
  return <CompliancePage pageData={COMPLIANCE_PAGES.privacyPolicy} />;
};

export default PrivacyPolicyPage;
